<!--Form Login-->
<mdb-card class="animated card-login position-absolute"
          style="top: -50%;left: 0;width: 100%"
          [class.d-none]="formType !== 'login'" [class.flipInY]="formType === 'login'">
  <mdb-card-body >
    <!--Header-->
    <div class="text-center">
      <h3 class="white-text">
        <mdb-icon fas icon="user" class="white-text"></mdb-icon> Ingreso</h3>
      <hr class="hr-light">
    </div>
    <!--Body-->
    <form [formGroup]="loginForm" class="pt-3">

      <div class="alert alert-danger text-center" *ngIf="authenticationError"
           role="alert" translate>{{authenticationError}}</div>

      <div class="md-form">
        <mdb-icon fas icon="envelope" class="prefix white-text active"></mdb-icon>
        <input type="email" formControlName="email" class="text-white form-control" mdbInput>
        <label class="text-white">Correo electrónico</label>
        <mdb-error *ngIf="loginHasError('email', 'required'); else error_email_3">Se requiere un correo electrónico</mdb-error>
        <ng-template #error_email_3>
          <mdb-error *ngIf="loginHasError('email', 'email')">Formato de correo electrónico no válido.</mdb-error>
        </ng-template>
      </div>
      <div class="md-form">
        <mdb-icon fas icon="lock" class="prefix text-white active"></mdb-icon>
        <input type="password" formControlName="password" class="text-white form-control" mdbInput>
        <label class="text-white">Contraseña</label>
        <mdb-error *ngIf="loginHasError('password', 'required'); else error_password_5">Debe ingresar su contraseña.</mdb-error>
        <ng-template #error_password_5>
          <mdb-error *ngIf="loginHasError('password', 'minlength')">Longitud de la contraseña muy corta.</mdb-error>
        </ng-template>
      </div>
    </form>

    <div class="text-center mt-4">
      <button mdbBtn color="indigo" mdbWavesEffect
              (click)="login()">Ingresar</button>
      <hr class="hr-light mb-3 mt-4">
      <div class="inline-ul text-center d-flex justify-content-center">
        <a class="btn btn-link text-white-50" href="javascript:void(0)"
           (click)="onGoToRegister.emit()">
          Solicitar registro
        </a>
      </div>
    </div>
  </mdb-card-body>
</mdb-card>
<!--/.Form-->
